import { z } from "zod";
import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";

export const FontSizeUnit = z.enum(["Pixels", "Rem", "Percent"]);

export const FontSizeValue = z.object({
  unit: DimensionUnit,
  measure: z.number(),
});

export const FontSizeTokenData = tokenAliasOrValue(FontSizeValue);

export type FontSizeUnit = z.infer<typeof FontSizeUnit>;
export type FontSizeValue = z.infer<typeof FontSizeValue>;
export type FontSizeTokenData = z.infer<typeof FontSizeTokenData>;
